module.exports = "<p>\n  general works!\n</p>\n"